module.exports = __webpack_public_path__ + "img/318.0c1d0c0f.jpg";